import React from "react";
import {IonModal} from "@ionic/react";
import CloseButton from "../../utils/buttons/CloseButton";
import MapExplanation from "./MapExplanation";

/**
 * Component available on mobile with an explanation of how to use the map.
 * @author Alizée Grand
 * @version 1.1
 * @creation 26/04/2021
 * @last_update 05/01/2022
 **/
class MobileExplanationPopup extends React.Component<{
    /**
     * Whether the modal is open or not.
     */
    isOpen: boolean,
    /**
     * Function to close the pop-up.
     */
    onExplanationClick: () => void,
}> {

    render() {

        return (

            <IonModal isOpen={this.props.isOpen}
                      onDidDismiss={this.props.onExplanationClick}
                      id="explanationPopup">
                <CloseButton onClickAction={this.props.onExplanationClick}/>
                <MapExplanation />
            </IonModal>

        );

    }

}

export default MobileExplanationPopup;
